import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Card, Space } from 'antd'
import { Outlet } from 'react-router-dom'

const ShortURLsContainer = () => {
  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={translate('navBar.shortURLsTitle')}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default ShortURLsContainer
